<div class="main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
      {{ opsTimesheet.Breadcrumb }}
    </span>
  </div>
  <div class="timesheet-container">
    <div class="timesheet-table-container">
      <div class="header">
        <div class="card-title-static">
          <span class="ct-badge"><i class="material-icons">schedule</i></span>
          <span class="ct-text">Timesheets</span>
        </div>
        <div class="timesheet-details-search">
          <div class="op-search">
            <i class="material-icons op-search-ic">search</i>
            <input
              type="text"
              [value]="filterValue"
              (keyup)="searchTimesheet($event)"
              placeholder="Search employee…"
              aria-label="Search timesheets"
            />
            <button
              *ngIf="filterValue?.length && filterValue.length > 0"
              class="op-search-clear"
              (click)="clearInput()"
              aria-label="Clear search"
            >✕</button>
          </div>
          <div class="fs-field" *ngIf="resetVendor">
            <span class="fs-label">Vendor</span>
            <select
              class="native-select has-icon icon-vendor"
              aria-label="Vendor"
              (change)="onVendorSelect($any($event.target).value)"
            >
              <option value="" [selected]="!selectedVendor.length">All Vendors</option>
              <option *ngFor="let o of vendorOptions" [value]="o.value" [selected]="selectedVendor.includes(o.value)">{{ o.label }}</option>
            </select>
          </div>
          <div class="fs-field" *ngIf="resetDntLeader">
            <span class="fs-label">D&T Leader</span>
            <select
              class="native-select has-icon icon-person"
              aria-label="D&T Leader"
              (change)="onDntLeaderSelect($any($event.target).value)"
            >
              <option value="" [selected]="!selectedDntLeader.length">All D&T Leaders</option>
              <option *ngFor="let o of dntLeaderOptions" [value]="o.value" [selected]="selectedDntLeader.includes(o.value)">{{ o.label }}</option>
            </select>
          </div>
          <div class="fs-field" *ngIf="resetEmployeeStatus">
            <span class="fs-label">Employee Status</span>
            <select
              class="native-select has-icon icon-person"
              aria-label="Employee Status"
              (change)="onEmployeeStatusSelect($any($event.target).value)"
            >
              <option *ngFor="let o of employeeStatusOptions" [value]="o.value" [selected]="selectedEmployeeStatus === o.value">{{ o.label }}</option>
            </select>
          </div>
          <div class="fs-field" *ngIf="resetStatus">
            <span class="fs-label">{{ timesheetLabels.status }}</span>
            <select
              class="native-select has-icon icon-flag"
              aria-label="Status"
              (change)="onStatusSelect($any($event.target).value)"
            >
              <option *ngFor="let o of statusOptions" [value]="o.value" [selected]="selectedStatus === o.value">{{ o.label }}</option>
            </select>
          </div>
          <div class="fs-field">
            <span class="fs-label">Month</span>
            <select
              class="native-select has-icon icon-cal"
              aria-label="Month"
              (change)="onMonthSelect($any($event.target).value)"
            >
              <option *ngFor="let o of monthOptions" [value]="o.value" [selected]="o.value === selectedOption">{{ o.label }}</option>
            </select>
          </div>
          <div class="download-btn-container">
            <emerald-button
              [label]="'Download'"
              [type]="'Secondary'"
              [icon]="'download'"
              (onClick)="download()">
            </emerald-button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="displayData?.length; else noDataTemplate">
        <div class="op-table-wrap">
          <table class="op-table ts-table">
            <thead>
              <tr>
                <th class="c col-select">
                  <input
                    type="checkbox"
                    class="row-check"
                    aria-label="Select all rows on this page"
                    [checked]="allPageSelected"
                    (change)="toggleAllPage($any($event.target).checked)"
                  />
                </th>
                <th class="sortable" (click)="sortBy('employeeName')">Employee <span class="op-sort" [class.asc]="sortField === 'employeeName' && sortDir === 'asc'" [class.desc]="sortField === 'employeeName' && sortDir === 'desc'"></span></th>
                <th class="sortable" (click)="sortBy('vendorName')">Vendor <span class="op-sort" [class.asc]="sortField === 'vendorName' && sortDir === 'asc'" [class.desc]="sortField === 'vendorName' && sortDir === 'desc'"></span></th>
                <th class="sortable c" (click)="sortBy('workingHrs')">Total Working Hrs <span class="op-sort" [class.asc]="sortField === 'workingHrs' && sortDir === 'asc'" [class.desc]="sortField === 'workingHrs' && sortDir === 'desc'"></span></th>
                <th class="sortable c" (click)="sortBy('leavesAvailed')">Leaves Availed <span class="op-sort" [class.asc]="sortField === 'leavesAvailed' && sortDir === 'asc'" [class.desc]="sortField === 'leavesAvailed' && sortDir === 'desc'"></span></th>
                <th class="sortable c" (click)="sortBy('billableHrs')">Billable Hrs <span class="op-sort" [class.asc]="sortField === 'billableHrs' && sortDir === 'asc'" [class.desc]="sortField === 'billableHrs' && sortDir === 'desc'"></span></th>
                <th class="sortable" (click)="sortBy('status')">Status <span class="op-sort" [class.asc]="sortField === 'status' && sortDir === 'asc'" [class.desc]="sortField === 'status' && sortDir === 'desc'"></span></th>
                <th class="c">Calendar</th>
                <th>Action</th>
                <th class="sortable" (click)="sortBy('location')">Location <span class="op-sort" [class.asc]="sortField === 'location' && sortDir === 'asc'" [class.desc]="sortField === 'location' && sortDir === 'desc'"></span></th>
                <th class="sortable" (click)="sortBy('l3ManagerName')">D&T Leader <span class="op-sort" [class.asc]="sortField === 'l3ManagerName' && sortDir === 'asc'" [class.desc]="sortField === 'l3ManagerName' && sortDir === 'desc'"></span></th>
                <th class="sortable" (click)="sortBy('reportingManager')">Reporting Manager <span class="op-sort" [class.asc]="sortField === 'reportingManager' && sortDir === 'asc'" [class.desc]="sortField === 'reportingManager' && sortDir === 'desc'"></span></th>
                <th class="sortable" (click)="sortBy('employeeStatus')">Employee Status <span class="op-sort" [class.asc]="sortField === 'employeeStatus' && sortDir === 'asc'" [class.desc]="sortField === 'employeeStatus' && sortDir === 'desc'"></span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of pagedData">
                <td class="c col-select">
                  <input
                    type="checkbox"
                    class="row-check"
                    [attr.aria-label]="'Select ' + v.employeeName"
                    [checked]="isSelected(v)"
                    (change)="toggleRow(v, $any($event.target).checked)"
                  />
                </td>
                <td>
                  <div class="ts-emp">
                    <span class="ts-name" [attr.title]="v.employeeName || null">{{ v.employeeName }}</span>
                    <span class="ts-sub" [attr.title]="v.jobTitle || null">
                      <a class="op-jt mono" (click)="openEmployeeDetails(v)">{{ v.employeeId }}</a>
                      <span class="ts-job" *ngIf="v.jobTitle"> · {{ v.jobTitle }}</span>
                    </span>
                  </div>
                </td>
                <td [attr.title]="v.vendorName || null">{{ v.vendorName || '—' }}</td>
                <td class="c mono">{{ v.workingHrs }} Hrs</td>
                <td class="c mono">{{ v.leavesAvailed ?? '—' }}</td>
                <td class="c mono">{{ v.billableHrs }} Hrs</td>
                <td>
                  <span class="ts-status" *ngIf="v.status" [attr.title]="v.status">
                    <i class="material-icons ts-flag" [style.color]="getStatusColor(v.status)">flag</i>
                    <span class="ts-status-label">{{ v.status }}</span>
                  </span>
                </td>
                <td class="c">
                  <button class="ts-iconbtn" [attr.title]="timesheetLabels.getCalendar" (click)="openTimesheetCalendar(v)">
                    <i class="material-icons">date_range</i>
                  </button>
                </td>
                <td class="op-cell-actions">
                  <span class="ts-actions">
                    <button
                      class="ts-btn"
                      [disabled]="v.status !== 'Approved'"
                      (click)="RetriggerMail(v)"
                    ><i class="material-icons">mail</i>Resend</button>
                    <button class="ts-iconbtn danger" title="Delete timesheet" (click)="openDeleteConfirmation(v)">
                      <i class="material-icons">delete</i>
                    </button>
                  </span>
                </td>
                <td [attr.title]="v.location || null">{{ v.location || '—' }}</td>
                <td [attr.title]="v.l3ManagerName || null">{{ v.l3ManagerName || '—' }}</td>
                <td [attr.title]="v.reportingManager || null">{{ v.reportingManager || '—' }}</td>
                <td>
                  <div class="ts-emp">
                    <span>{{ v.employeeStatus || '—' }}</span>
                    <a *ngIf="v.employeeStatus === 'Inactive'" class="ts-exclude" (click)="excludeFromTimesheets(v)">
                      Don't include in timesheets
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="op-tfoot">
          <div class="op-info">
            Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ displayData.length }}</b> timesheets<ng-container *ngIf="selectedRows.length"> · <b>{{ selectedRows.length }}</b> selected</ng-container>
          </div>
          <div class="op-pager">
            <button class="pg" (click)="prevPage()" [disabled]="pageIndex === 1" aria-label="Previous page">‹</button>
            <button
              *ngFor="let pnum of pageWindow; trackBy: trackByIndex"
              class="pg"
              [class.on]="pnum === pageIndex"
              [disabled]="pnum === -1"
              (click)="goToPage(pnum)"
            >{{ pnum === -1 ? '…' : pnum }}</button>
            <button class="pg" (click)="nextPage()" [disabled]="pageIndex >= totalPages" aria-label="Next page">›</button>
          </div>
          <div class="op-psize">
            <span>Rows</span>
            <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
            </select>
          </div>
        </div>
      </ng-container>

      <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
          <div class="empty-state">
            <ng-container *ngIf="isDataLoaded">
              <h2 class="empty-state-title">{{ errorMsg }}</h2>
            </ng-container>
            <img [src]="imageSrc" [alt]="timesheetLabels.noRecordsIllustration" class="empty-state-image" />
          </div>
        </section>
      </ng-template>

    </div>

    <div *ngIf="isTimesheetCalendarOpen" class="modal-container">
      <div class="dim-background" (click)="closeTimesheetCalendar()"></div>
      <div class="modal-content">
        <app-ops-timesheet-calendar [componentName]="componentName" [candidateDetails]="selectedRowData"
          [selectedyear]="selectedyear" [selectedmonth]="selectedmonth" (refreshTimesheet)="loadTimesheetData()"
          (closeComponent)="closeTimesheetCalendar()"></app-ops-timesheet-calendar>
      </div>
    </div>
  </div>

  <!-- Employee Details Popup -->
  <app-employee-details
    [show]="showEmployeeDetailsPopup"
    [employee]="selectedEmployeeForDetails"
    [month]="month"
    [year]="year"
    (closePopup)="closeEmployeeDetailsPopup()"
    (lastWorkingDayUpdated)="onLastWorkingDayUpdated($event)"
  ></app-employee-details>

  <app-modal-wrapper *ngIf="showContractorProfile" [showModal]="showContractorProfile">
    <app-ops-contractor-profile
      [contractorData]="selectedContractor"
      (close)="showContractorProfile = false"
    ></app-ops-contractor-profile>
  </app-modal-wrapper>

  <app-confirmation-dialog
    [isOpen]="showExcludeConfirmation"
    [title]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.TITLE"
    [message]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.MESSAGE"
    [submitLabel]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.SUBMIT_LABEL"
    [cancelLabel]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.CANCEL_LABEL"
    (confirm)="onConfirmExclude()"
    (cancel)="onCancelExclude()">
  </app-confirmation-dialog>
  <app-confirmation-dialog
    [isOpen]="showDeleteConfirmation"
    [title]="TIMESHEET_CONSTANTS.DELETE_CONFIRMATION_DIALOG.TITLE"
    [messageHtml]="deleteConfirmationMessage"
    [submitLabel]="TIMESHEET_CONSTANTS.DELETE_CONFIRMATION_DIALOG.SUBMIT_LABEL"
    [cancelLabel]="TIMESHEET_CONSTANTS.DELETE_CONFIRMATION_DIALOG.CANCEL_LABEL"
    (confirm)="onConfirmDelete()"
    (cancel)="onCancelDelete()">
  </app-confirmation-dialog>
</div>